module.exports = __webpack_public_path__ + "media/Restaurant.3f029ae4.mp3";